import { createAction, props } from '@ngrx/store';
import { RequestLaborManagerCreate, ResponseLaborManagerCreate } from '../../shared/interfaces';
import { LaborManagerCreateTypes } from '../../shared/enums';

export const getLaborManagerCreate = createAction(
    LaborManagerCreateTypes.LABOR_MANAGER_CREATE,
    props<{ request: RequestLaborManagerCreate}>()
);

export const getLaborManagerCreateSucess = createAction(
    LaborManagerCreateTypes.LABOR_MANAGER_CREATE_SUCCESS,
    props<{ response: ResponseLaborManagerCreate }>()
);

export const getLaborManagerCreateError = createAction(
    LaborManagerCreateTypes.LABOR_MANAGER_CREATE_ERROR,
    props<{ payload: any }>()
);

export const cleanState = createAction(
    LaborManagerCreateTypes.CLEAN_STATE
);

